import { Reducer, useReducer } from "react";

type StateType = Record<string, any>;

function init(initialState: StateType) {
  return { ...initialState };
}

const useSetState = (initialState: StateType) => {
  const [state, setState] = useReducer<Reducer<any, any>, StateType>(
    (currentState, newState) => ({
      ...currentState,
      ...newState,
    }),
    initialState,
    init,
  );

  return [state, setState];
};

export default useSetState;
